import './Footer.css';



const Footer = () => {

    const phoneNumber = '+5511955881602';

    function sendMessage() {
        const message = encodeURIComponent(document.getElementById('floatingTextarea').value);
        const whatsappLink = `https://wa.me/${phoneNumber}/?text=${message}`;
        window.open(whatsappLink, '_blank');
        document.getElementById('floatingTextarea').innerHTML = '';
    }


    return (
        <>

        <section id="footer" name="footer">

            <div class="container py-4">
                <div class="row">

                    <div class="col-md-1 footer-box"></div>

                    <div class="col-md footer-box">
                        <img src={`${process.env.PUBLIC_URL}/logo_com_texto.png`} />
                        <p>Embarque na jornada do karatê em uma de nossas três academias. De Guaianases a Cidade Tiradentes, convidamos você a experimentar a disciplina, força e sabedoria que o karatê pode proporcionar.</p>
                    </div>

                    <div class="col-md footer-box">
                        <p class="title-footer"><mark>Envie uma mensagem!</mark></p>
                        <div class="form-floating">
                            <textarea class="form-control" placeholder="Leave a comment here" id="floatingTextarea"></textarea>
                            <label for="floatingTextarea">Mensagem</label>
                            <div class="text-end"><button class="btn btn-enviar mt-2 ml-auto" onClick={sendMessage}>Enviar</button></div>
                        </div>
                    </div>

                    <div class="col-md-1 footer-box"></div>

                </div>

                <p class="copyright">&copy; Todos os direitos reservados ADK Karatê Do Shotokan</p>
            </div>
        </section>

        </>
    )

}

export default Footer;
